import script from "./WeeklyArenaGoal.vue?vue&type=script&setup=true&lang=js"
export * from "./WeeklyArenaGoal.vue?vue&type=script&setup=true&lang=js"

import "./WeeklyArenaGoal.vue?vue&type=style&index=0&id=9fefec36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fefec36"]])

export default __exports__